import type { ReviewDetailAllOf } from './reviewDetailAllOf';
import type { ReviewDetailAllOfTwo } from './reviewDetailAllOfTwo';

export type ReviewDetail = ReviewDetailAllOf & ReviewDetailAllOfTwo;
